import { Basket, BasketItem } from 'menus/interfaces';

export const ADD_ITEM = 'ADD_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const UPDATE_ITEM_REVIEW = 'UPDATE_ITEM_REVIEW';
export const UPDATE_BASKET = 'UPDATE_BASKET';
export const UPDATE_SOCKET_BASKET = 'UPDATE_SOCKET_BASKET';

export type BasketAction =
  | { type: typeof ADD_ITEM; payload: BasketItem }
  | { type: typeof REMOVE_ITEM; payload: BasketItem }
  | { type: typeof UPDATE_ITEM_REVIEW; payload: BasketItem }
  | { type: typeof UPDATE_BASKET; payload: Basket }
  | { type: typeof UPDATE_SOCKET_BASKET };
